import React, { useContext, useEffect, useState } from 'react';
import Navbar from '../Home/Navbar';
import "./Profile.css"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import END_POINT from '../../END_POINT';

const Profile = () => {
    const userContext = useContext(UserContext);
    const [user, setUser] = useState(userContext);
    const navigate=useNavigate();
    const [updateUser, setUpdateUser] = useState({
        first:"",
        last:"",
        email:"",
        password:"",
        newpassword:"",
        oldpassword:""
    });
    
    useEffect(() => {
        setUpdateUser(user)
        
    }, []);
    
    
    const deleteAccount=async()=>{
        await fetch(`${END_POINT}/auth/deleteAccount/${user._id}`)
        .then(res=>res.json())
        .then(data=>{
            localStorage.removeItem("User");
            
            setUser("");
            
            navigate("/");
            window.location.reload(true);
        })
    }
    const handleInput=(e)=>{
        setUpdateUser({...updateUser,[e.target.name]:e.target.value})
        
    }
    const submitUpdate=async()=>{
        const res = await fetch(`${END_POINT}/auth/updateProfile`, {
            method: "POST",
            headers: { 'Content-Type': "application/json" },
            body: JSON.stringify(updateUser)
        })
        if(res.status===200){
            res.json().then(data=>{
                localStorage.setItem("User", JSON.stringify(data));
                setUser(data)
                setUpdateUser(data)
            })
            toast.success('Account Updated Successfully!', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              });
              
            // navigate("/login")
          }
          else if(res.status==500){
            toast.error('Update Failed!', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              });
          }
           
    }
    return (
        <div>
            <ToastContainer
position="top-center"
autoClose={5000}
hideProgressBar
newestOnTop
closeOnClick
rtl={false}
pauseOnFocusLoss={false}
draggable
pauseOnHover={false}
/>
            <Navbar />
            <div className="profilebc">

            
            <div style={{ "float": "right" }}>
                            <button data-toggle="modal" data-target="#exampleModaldel" className='btn bg-light deleteAccount my-3'>Delete Account</button>
                        </div>
            <div  className="profileBody row">
                
                    <img className='col-md-5 mx-3' style={{"width":"200px","float":"left"}} src={user.imageUrl} alt="" />
                        
                        {user &&<div className='details col-md-7 mx-3'>
                            <p className='detail mx-3'>Name: <b>{user.first} {user.last}</b></p>
                            <p className='detail mx-3'>Email: <b>{user.email}</b></p>
                            <p className='detail mx-3'>Member Since: <b>{new Date(user.createdAt).toDateString()},  {new Date(user.createdAt).toLocaleTimeString()}</b></p>
                            <input data-toggle="modal" data-target="#exampleModal" className='mx-3' type="submit" value="Edit Profile" />
                        </div>}
                        
                 
              
            </div>
            </div>
            {/* modal */}


<div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">Update Profile</h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
      <div className="form-group">
                    <label htmlFor="exampleFormControlInput1">First Name</label>
                    <input value={updateUser.first} name='first' onChange={handleInput} type="text" className="form-control"  />
                </div>
                
                <div className="form-group">
                    <label>Last Name</label>
                    <input value={updateUser.last} name='last' onChange={handleInput} type="text" className="form-control"  />
                </div>
                <div className="form-group">
                    <label>Email</label>
                    <input value={updateUser.email} name='email' onChange={handleInput} type="text" className="form-control"  />
                </div>
                <div className="form-group">
                    <label>Old Password</label>
                    <input value={updateUser.oldpassword}  name='oldpassword' placeholder='you must provide it to update' onChange={handleInput} type="text" className="form-control" id="exampleFormControlInput1" />
                </div>
                <div className="form-group">
                    <label>New Password</label>
                    <input value={updateUser.newpassword}  name='newpassword' placeholder='optional' onChange={handleInput} type="text" className="form-control" />
                </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        <button onClick={submitUpdate}  type="button" data-dismiss="modal" className="btn btn-primary">Update</button>
      </div>
    </div>
  </div>
</div>
            {/* modal end */}

            {/* Post delete warning modal starts here */}



            <div className="modal fade" id="exampleModaldel" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">

                    <div className="modal-content" style={{ "textAlign": "center" }} >

                        {/* <div className="modal-header" > */}
                        <div className="d-flex justify-content-center">
                            <img src="https://img.icons8.com/ios/100/FF0000/cancel.png" />

                        </div>

                        {/* </div> */}
                        <div className="modal-body">
                            <h3 >Are you sure?</h3>
                            <br />
                            <p style={{ "color": 'gray' }}>Do you really want to delete these records? This process cannot be undone.</p>
                        </div>

                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button onClick={deleteAccount} type="button" data-dismiss="modal" className="btn btn-danger">Delete</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Post delete warning modal ends here */}
        </div>
    )
};

export default Profile;
